import moment from "moment";

export const displayDateWithTime = (
  value: string,
  at?: string | null,
  locale?: string | null,
): string => {
  const m = locale ? moment(value).locale(locale) : moment(value);
  return `${m.format("DD MMM YYYY")}${at ? ` ${at}` : ","} ${m.format("HH:mm")}`;
};
